import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';

class SrOptionSelectionModal extends Component {
  static propTypes = {
    headline: PropTypes.string,
    optionItems: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })).isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    includeOther: PropTypes.bool,
  }

  constructor(props) {
    super(props);
    this.state = {
      otherReason: null,
    };
  }

  _onSubmit = (value) => {
    this.props.onSubmit(value);
  }

  _onSubmitOther = () => {
    const { otherReason } = this.state;
    if (otherReason.length >= 30) {
      this.props.onSubmit(otherReason);
    }
  }

  _onCancel = () => {
    this.props.onCancel();
  }

  render() {
    const { optionItems, headline, includeOther } = this.props;

    return (
      <Portal>
        <div className='optionSelectionModal failureReasons'>
          <div className='backdrop' onClick={this._onCancel}>
            <div className='form' onClick={(event) => event.stopPropagation()}>
              <h1>{headline}</h1>
              {optionItems.map(({ label, value }) => (
                <div
                  key={value}
                  onClick={() => this._onSubmit(value)}
                >
                  <span className='button white small'>{label}</span>
                </div>
              ))}
              {includeOther && (
                <input
                  className='otherReason'
                  placeholder='Other... (partner will read this. 30 char. minimum)'
                  onChange={(event) => {
                    this.setState({
                      otherReason: event.target.value,
                    });
                  }}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      this._onSubmitOther();
                    }
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrOptionSelectionModal.displayName = 'SrOptionSelectionModal';

export default SrOptionSelectionModal;
